export const questions = [
    {
        question: "How do I request time off?", 
        answer: "Go to Attendance & Leave > Request Leave to submit a leave request."
    },
    {
        question: "Where can I view my payslips?", 
        answer: "Navigate to Payslips from the main menu to view and download your salary slips."
    },
    {
        question: "How do I enroll in training courses?", 
        answer: "Visit Training & Development > Browse Training to explore and enroll in available courses."
    },
    {
        question: "What are Hyvid Points?", 
        answer: "Hyvid Points are part of our Hyvid Rewards program. Earn gift credits through achievements and recognition across 9 performance categories."
    },
];